import React from 'react';

import {
  WmsIcon,
  AdmIcon,
  InvIcon,
  ImpIcon,
  BiIcon,
} from '../assets/ModulesIcons';

export function handleIcons(iconName: string): JSX.Element {
  switch (iconName) {
    case 'wms':
      return <WmsIcon />;
    case 'inv':
      return <InvIcon />;
    case 'pre':
      return <WmsIcon />;
    case 'imp':
      return <ImpIcon />;
    case 'bi':
      return <BiIcon />;
    default:
      return <AdmIcon />;
  }
}
